import { Button } from '@navi/web-ui/lib/primitives';
import React from 'react';
import { Due } from '../../interfaces/CaseDetail.type';
import { getFeeWaiverButtonLabel } from './utils';

interface IFeeWaiverActionButtons {
  emiItem: Due;
  showAdjustmentView: boolean;
  disabled: boolean;
  waivedValue: number;
  onWaivePenalty: () => void;
  onConfirmAdjustment: () => void;
  onBack: () => void;
}

const FeeWaiverActionButtons: React.FC<IFeeWaiverActionButtons> = ({
  showAdjustmentView,
  emiItem,
  disabled,
  waivedValue,
  onWaivePenalty,
  onBack,
  onConfirmAdjustment
}) => {
  const { isMaxWaived, action, unpaidDueAmount, additionalWaiverInfo } = emiItem || {};
  const buttonTitle = getFeeWaiverButtonLabel(
    action,
    waivedValue,
    unpaidDueAmount,
    additionalWaiverInfo?.holdAllowedTill || ''
  );
  if (isMaxWaived) {
    return null;
  }
  if (showAdjustmentView) {
    return (
      <div className="flex gap-2">
        <Button variant="secondary" onClick={onBack} className="flex-1">
          Back
        </Button>
        <Button onClick={onConfirmAdjustment} className="flex-1">
          Confirm
        </Button>
      </div>
    );
  }
  return (
    <Button fullWidth disabled={disabled} onClick={onWaivePenalty}>
      {buttonTitle}
    </Button>
  );
};

export default FeeWaiverActionButtons;
